export default function Footer() {
  const scrollToAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 max-w-7xl mx-auto py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-sun-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-900">
                向日葵视频
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              向日葵视频是国内领先的水果植物类视频平台聚合导航入口，收录香蕉视频、西瓜视频免费、蜜桃视频、樱花视频等优质水果视频在线平台资源，提供高清免费在线观看，不缓冲流畅体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground-900 mb-4">快速导航</h3>
            <nav className="space-y-2">
              {[
                { label: '精选专题', href: '#carousel' },
                { label: '热门视频', href: '#media' },
                { label: '热度榜单', href: '#ranking' },
                { label: '分类精选', href: '#cards' },
                { label: '主题索引', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToAnchor(item.href);
                  }}
                  className="block text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground-900 mb-4">水果视频平台</h3>
            <nav className="space-y-2">
              {['香蕉视频', '西瓜视频免费', '蜜桃视频', '樱花视频', '水果视频在线', '植物视频平台'].map((name) => (
                <a
                  key={name}
                  href="#carousel"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToAnchor('#carousel');
                  }}
                  className="block text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {name}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground-900 mb-4">合作伙伴</h3>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
              诚邀优质视频平台与内容创作者加入合作，共同打造丰富多元的水果视频在线生态。
            </p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToAnchor('#contact');
              }}
              className="inline-flex items-center gap-1.5 mt-3 text-xs md:text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-mail-add-line"></i>
              申请合作
            </a>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-background-200">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400 text-center sm:text-left">
              &copy; {new Date().getFullYear()} 向日葵视频 - 水果植物视频平台大全。本站为导航聚合站，不存储任何视频内容。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#about');
                }}
                className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
              >
                关于我们
              </a>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#faq');
                }}
                className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
              >
                常见问答
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#contact');
                }}
                className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
              >
                联系投稿
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}